<!-- Note Details Tab Component -->
<div class="note-details-tab">
  @if (noteData) {
    <!-- Summary view for edit mode -->
    @if (displayMode === 'summary') {
      <div class="details-section">
        <h4 class="details-section__title">Information</h4>
        <div class="details-grid">
          <div class="detail-field">
            <label class="detail-field__label">Status</label>
            <div class="detail-field__value">
              <span
                [ngClass]="getStatusPillClass()"
                [style.background-color]="getSummaryStatusColor()"
                [style.color]="getSummaryStatusColor() ? '#ffffff' : null">
                {{ getSummaryStatusName() }}
              </span>
            </div>
          </div>
          <div class="detail-field">
            <label class="detail-field__label">Priority</label>
            <div class="detail-field__value">
              <span [ngClass]="getPriorityPillClass()">
                <mat-icon class="pill-icon">flag</mat-icon>
                {{ getSummaryPriorityLabel() }}
              </span>
            </div>
          </div>
          <div class="detail-field">
            <label class="detail-field__label">Created By</label>
            <div class="detail-field__value">{{ getCreatedByName() }}</div>
          </div>
          <div class="detail-field">
            <label class="detail-field__label">Created Date</label>
            <div class="detail-field__value">
              {{ (getCreatedOn() | date: 'MMM d, y h:mm a') || '-' }}
            </div>
          </div>
        </div>
      </div>
    } @else {
      <!-- Note Information Section -->
      <div class="details-section">
        <h4 class="details-section__title">Note Information</h4>
        <div class="details-grid">
          <!-- Module -->
          <div class="detail-field">
            <label class="detail-field__label">Module</label>
            <div class="detail-field__value">{{ getModuleName() }}</div>
          </div>
          <!-- Reference -->
          <div class="detail-field">
            <label class="detail-field__label">Reference</label>
            <div class="detail-field__value">{{ getReferenceName() }}</div>
          </div>
          <!-- Created By -->
          <div class="detail-field">
            <label class="detail-field__label">Created By</label>
            <div class="detail-field__value">{{ getCreatedBy() }}</div>
          </div>
          <!-- Created On -->
          <div class="detail-field">
            <label class="detail-field__label">Created On</label>
            <div class="detail-field__value">
              {{ (getCreatedOn() | date: 'MMM d, y h:mm a') || '-' }}
            </div>
          </div>
          <!-- Last Updated -->
          <div class="detail-field">
            <label class="detail-field__label">Last Updated</label>
            <div class="detail-field__value">
              {{ (getUpdatedOn() | date: 'MMM d, y h:mm a') || '-' }}
            </div>
          </div>
          <!-- Attachments -->
          <div class="detail-field">
            <label class="detail-field__label">Attachments</label>
            <div class="detail-field__value">
              {{ getAttachmentCount() }} file{{ getAttachmentCount() !== 1 ? 's' : '' }}
            </div>
          </div>
        </div>
      </div>
      <!-- Mentions Section -->
      @if (getMentions().length > 0) {
        <div class="details-section">
          <h4 class="details-section__title">Mentioned Users</h4>
          <div class="mentions-list">
            @for (mention of getMentions(); track mention) {
              <div class="mention-item">
                <div class="mention-avatar">
                  <mat-icon>person</mat-icon>
                </div>
                <div class="mention-info">
                  <div class="mention-name">{{ mention.name || 'Unknown User' }}</div>
                  <div class="mention-type">{{ mention.type || 'User' }}</div>
                </div>
              </div>
            }
          </div>
        </div>
      }
    }
    <!-- Full detail view -->
  } @else {
    <div class="empty-state">
      <mat-icon class="empty-state__icon">description</mat-icon>
      <p class="empty-state__message">No details available</p>
    </div>
  }

  <!-- Empty State -->
</div>
